export class AccessDeniedError extends Error {
  constructor() {
    super('Acesso negado! Você não possui permissão para acessar esse recurso.')
  }
}
